const bsPrefixes = {
	badge: 'cobalt-badge',
	btn: 'cobalt-button',
	'form-label': 'cobalt-form__label',
	'form-control': 'cobalt-form__control',
	'form-check': 'cobalt-form__check',
	'modal-title': 'cobalt-modal__title',
	'modal-header': 'cobalt-modal__header',
	'modal-body': 'cobalt-modal__body',
	'modal-footer': 'cobalt-modal__footer',
	card: 'cobalt-card',
	'card-header': 'cobalt-card__header',
	'card-title': 'cobalt-card__title',
	'card-subtitle': 'cobalt-card__subtitle',
	'card-body': 'cobalt-card__body',
};

export default bsPrefixes;
